<template>
    <div class="vip-btn-box">
        <el-dialog :title="titleText" :visible.sync="dialogVisible" :width="width" top="30vh" :before-close="handleClose">
            <el-input v-if="infoObj.templateStatus == 1"  v-model="infoObj.testFailReason" class="new-input" :disabled="true"></el-input>
            <el-input v-else v-model="phone" placeholder="请输入准确手机号进行测试" class="new-input" clearable maxlength="11" oninput="value=value.replace(/[^\d.]/g,'')" />
            <span style="color: #ee4234;font-size:16px;" v-if="infoObj.templateStatus !== 1">注意 ：测试短信只能发送一次</span>
            <div class="money-confirm" @click="sunBtn">{{ btn }}</div>
        </el-dialog>
    </div>
</template>
  
  <script>
import requstsMethod from "common/const";
import { response } from "network/response";
export default {
    data () {
        return {
            infoObj: {},
            phone: '',
            btn: '',
            titleText: '',
            dialogVisible: false,
            disabled: false,
        }
    },
    props: ['title', 'width'],
    methods: {
        handleClose () {
            this.dialogVisible = false
        },
        getInit (item) {
            console.log(item);
            this.phone = ''
            this.titleText = this.title
            item.testStatus !== 0 && item.templateStatus !== 1 ? this.btn = '再次发送' : this.btn = '确定'
            this.infoObj = item
            this.infoObj.templateStatus !== 1 ? this.infoObj.testFailReason = this.infoObj.testFailReason : this.infoObj.testFailReason = this.infoObj.reason
            this.dialogVisible = true
            item.testStatus == 0 ? this.disabled = false : this.disabled = true
        },
        sunBtn () {
            if (this.infoObj.templateStatus == 1) {
                this.dialogVisible = false
            } else {
                this.infoObj.testStatus == 0 ? this.getSub() : this.titleText = '请输入手机号进行测试', this.btn = '确定'
            }
        },
        async getSub () {
            if (this.phone.length == 11) {
                const params = {
                    billiardsId: this.infoObj.billiardsId,
                    marketingSmsTemplateId: this.infoObj.marketingSmsTemplateId,
                    phoneNumber: this.phone
                }
                const data = await response(requstsMethod.fun_Get_authorized_marketing_wake_sms_test_send, params)
                if (data) {
                    this.$message({ type: 'success', message: '测试成功' })
                } else {
                    this.$message({ type: 'error', message: '测试失败' })
                }
                this.dialogVisible = false
                this.$emit('subRes')
            } else {
                this.$message({ type: 'error', message: '请输入正确手机号' })
            }

        }
    }
}
  </script>
  
  <style lang="scss">
.vip-btn-box {
    .el-dialog {
        position: relative !important;
        margin: 0 auto 50px;
        border-radius: 2px;
        box-shadow: 0 0px 5px 0 #000 !important;
        box-sizing: border-box;
        padding-top: 9px;
        background-color: #4f4f4f !important;
        border-radius: 62px/59px 0px 59px 0px;

        .el-dialog__header {
            margin: 0 10px;
            padding: 0 0 0 31px;
            height: 62px;
            line-height: 62px;
            font-size: 24px;
            text-align: left;
            padding-left: 31px !important;
            border-radius: 62px/59px 0 0 0;
            box-shadow: 0px 0px 10px #000 inset;

            .el-dialog__title {
                color: #00fe81 !important;
            }

            .el-dialog__headerbtn {
                position: absolute;
                top: 17px !important;
                right: 15px !important;
                width: 45px;
                height: 45px;
                line-height: 45px;
                font-size: 40px;
                border-radius: 50%;
                box-shadow: 0px 0px 5px #000;

                .el-icon-close {
                    position: relative;
                    color: #fff;
                    font-weight: 600;
                }
            }
        }

        .el-dialog__body {
            background-color: #4f4f4f !important;
            border-radius: 62px/59px 0px 59px 0px;
            .el-input {
                margin: 10px 0;
                .el-input__inner {
                    height: 50px;
                    line-height: 50px;
                    color: #fff;
                    font-size: 18px;
                    font-weight: 600;
                    letter-spacing: 1px;
                    background-color: #3e3e3e;
                    border: none;
                    box-shadow: 0 0 5px #000 inset;
                }
            }
            input::input-placeholder {
                color: red;
            }
            .money-confirm {
                text-align: center;
                margin: 15px 10px 0;
                width: calc(100% - 20px);
                height: 62px;
                line-height: 62px;
                background: #ffb900;
                font-size: 24px;
                color: #2b2b2b;
                box-shadow: 0px 0px 5px #000 inset;
                border-radius: 0 0 62px/59px 0;
                cursor: pointer;
            }

            .money-confirm:hover {
                font-size: 24px;
                color: #fff;
                background: rgba(247, 179, 90, 1);
            }
        }
    }
}
</style>